import { render, staticRenderFns } from "./ImportChassisModal.vue?vue&type=template&id=4b480390&scoped=true"
import script from "./ImportChassisModal.vue?vue&type=script&lang=js"
export * from "./ImportChassisModal.vue?vue&type=script&lang=js"
import style0 from "./ImportChassisModal.vue?vue&type=style&index=0&id=4b480390&prod&lang=scss&scoped=true"
import style1 from "./ImportChassisModal.vue?vue&type=style&index=1&id=4b480390&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b480390",
  null
  
)

export default component.exports